import {useState, useRef, useEffect} from 'react';

import editImg from '../../../../../assets/pen-solid-cultured-50.png';

import styles from '../../../../../styles/case/aside/EditableLabel.module.scss';


function EditableLabel(props) {
  const [editable, setEditable] = useState(false);
  const inputRef = useRef(null);

  function onEdit() {
    inputRef.current.value = props.value || '';
    setEditable(true);
  }

  function onSave() {
    props.onSave && props.onSave(inputRef.current.value);
    setEditable(false);
  }

  function onCancel() {
    setEditable(false);
  }

  useEffect(() => {
    if (!editable) return;
    inputRef.current.focus();
    inputRef.current.select();
  }, [editable])

  useEffect(() => {
    setEditable(false);
  }, [props.default]);

  return (
    <div style={{width: "100%", position: "relative"}}>
      <div style={editable ? {} : { display: 'none' }} className={styles.edit}>
        <input ref={inputRef} onKeyUp={(e) => {
          if (e.key === 'Enter') onSave();
          if (e.key === 'Escape') onCancel();
        }} />
        <button onClick={onCancel}>cancel</button>
        <button onClick={onSave}>save</button>
      </div>
      <div style={!editable ? {} : { display: 'none' }} className={styles.readonly}>
        <p>{props.value || props.default}</p>
        <img src={editImg} alt="edit" onClick={onEdit}/>
      </div>
      </div>
  );
}

export default EditableLabel;